<template>
<v-navigation-drawer :app="!largeScreen" class="mb-10" v-model="drawer" style="z-index:20;" 
      
      v-bind="$attrs"
       :class="{'pt-10': platform=='ios'}"
        :style="largeScreen? 'height:auto' : ''"
       :styles="largeScreen? `margin-top:${margin}px;height:calc(100vh - ${margin}px)`: null">
      <template v-slot:prepend>
      <v-list-item v-if="user" to="/settings">
      <v-list-item-avatar v-if="user.avatar">
        <v-img :src="user.avatar"></v-img>
      </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6" v-text="user.name ? user.name : user.phone">
            
          </v-list-item-title>
          <v-list-item-subtitle v-if="address" v-text="address.name" style="white-space: normal;">
            subtext
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list
        
        
      >
        <v-list-item
          v-for="item in items.filter(item=>item.active)"
          :key="item.title"
          @click="handleClick(item)"
          :to="item.to"
        >
          <v-list-item-icon class="mr-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.count" v-text="item.count">
          </v-list-item-action>
        </v-list-item>
        <!--v-divider></v-divider>
        <v-list-item 
          v-for="item in languages" :key="item.title" 
          @click="changeLocale(item.language)"
          link
        >
          <v-list-item-icon class="mr-2">
            <flag :iso="item.flag" v-bind:squared=false />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title :class="{'grey--text': locale !== item.language}">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon v-if="locale == item.language">
            <v-icon small>check</v-icon>
          </v-list-item-icon>
        </v-list-item-->
      </v-list>
      
      <template v-slot:append>
        <v-divider></v-divider>
         <v-list-item
          link @click="handleLogout"
        >
          <v-list-item-icon class="mr-2">
            <v-icon>logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="$t('Menu.logout')"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import i18n from '@/plugins/i18n';
  export default {
    props: ['value', 'address', "dark", 'scrollTop','stamps','orders','deliveries'],
    data () {
      return {
            languages: [
              { flag: 'nl', language: 'nl', title: 'Nederlands' },
              { flag: 'us', language: 'en', title: 'English' }
              
          ]
        }
    },
    computed: {
        ...mapGetters([
        'user', 'courier'
      ]),
      margin(){
          let m = this.$config.page.bannerHeight+3-this.scrollTop
          if (m > 47) return m
          return 47
        },
        locale(){
          return i18n.locale
        },
        items() {
          let c = this.courier ? 1 : 0
          return  [
              { title: this.$t('Menu.fetch'), icon: 'mdi-bike-fast', value:0, type: '', close: true, click: "setTab", active: this.courier, count: this.deliveries},
              { title: this.$t('Common.orderfood'), icon: 'restaurant', to: "/dashboard", value:0 +c, click: "setTab", type: 'deliver', close: true, active:true},
              { title: this.$t('Common.stamps'), icon: 'savings', value:1+c, click: "setTab", close: true, active:true, count: this.stamps},
              { title: this.$t('Common.orders'), icon: 'list', value:2+c, click: "setTab", close: true, active:true, count: this.orders},
             
              
              /*{ title: this.$t('Menu.orders'), icon: 'mdi-format-list-text', to: "/orders", value:1, type: '', close: true},*/
               { title: this.$t('Common.clublist'), icon: 'hub', value:this.courier ? 4 : 3, type: '', close: true , click: "setTab", active:true},

              { title: this.$t('Menu.settings'), icon: 'manage_accounts', to: "/settings", type: '', close: true, active:true},
              { title: this.$t('Menu.theme') + ': ' + (this.dark ? this.$t('Menu.dark') : this.$t('Menu.light')), icon: 'format_paint', click:"setDark", value: !this.dark, active: !this.largeScreen},
              /*{ title: this.$t('Menu.settings'), icon: 'settings' },*/
            ]
        },
        drawer:{
            get(){
                return this.value
            },
            set(value){
                this.$emit('input', value)
            }
        }
    },
    mounted(){
        this.changeLocale(this.$store.state.config.lang) 
    },
    methods: {
      ...mapActions([
        'setConfig',
        'logout',
        'login'
      ]),
    handleClick(menu){
        if (menu.click && this[menu.click]) this[menu.click](menu)
        if (menu.close) this.drawer = false
    },
    setTab(menu){
      this.setConfig({'tabs': menu.value})
      //this.setConfig({'type': menu.type})
    },
    goToSettings(menu){
      this.$emit('settings',menu)
    },
    setDark(menu){
      this.$vuetify.theme.dark = menu.value
      this.setConfig({'dark': menu.value})
    },
    changeLocale(locale) {
      if (!locale) return false
        i18n.locale = locale;
        this.setConfig({'lang': locale})
    },
    handleLogout(){
      this.logout()
      this.$router.push('/')
    },

    
  },
  }
</script>
<style>
.v-list .v-list-item--active .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-list .v-list-item--active {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-list-item--link:before {
    background-color: transparent!important;
}
</style>
